import { useState } from "react";
import styles from "./star-ratings.module.scss";

function AddRatings(props: any) {
  const [rating, setRating] = useState(props.rating);
  function handleSelect(index: any) {
    setRating(index + 1);
    props.changeRating(index + 1);
  }
  return (
    <div className={`${styles.star_ratings} ${styles.star_ratings_large}`}>
      {[...Array(rating)].map((n, i) => (
        <i
          key={i}
          className="fa fa-star pointer"
          onClick={() => handleSelect(i)}
        />
      ))}
      {[...Array(5 - rating)].map((n, i) => (
        <i
          key={i}
          className="fa fa-star-o pointer"
          onClick={() => handleSelect(i + rating)}
        />
      ))}
    </div>
  );
}

export default AddRatings;
